import React from "react";
import PropTypes from "prop-types";
import { DialysisPath } from "../DialysisPath";
import { DialysisHolder } from "../DialysisHolder";
import { LabelCell } from "../LabelCell";
import { CELL_TYPE } from "../DialysisDragDrop.constants";
import { DialysisDragDropContext } from "../DialysisDragDrop.utils";

const COLUMN_TYPE = "BAND_COLUMN";

export function BandColumn(props) {
  const { getGridTemplateRows } = React.useContext(DialysisDragDropContext);

  const getClassName = (cellType) => {
    return `${props.className}__${cellType.toLowerCase()}`;
  };

  const getCellId = (cellId) => {
    return `${props.colId}_${cellId}`;
  };

  const renderCell = (cell) => {
    switch (cell.cellType) {
      case CELL_TYPE.LABEL_CELL:
        return (
          <LabelCell
            key={cell.cellId}
            className={getClassName(cell.cellType)}
            label={cell.label}
            headingAriaLabel={props.headingAriaLabel}
          />
        );
      case CELL_TYPE.DIALYSIS_HOLDER:
        return (
          <DialysisHolder
            id={props.id}
            key={cell.cellId}
            cellId={getCellId(cell.cellId)}
            colId={props.colId}
            className={getClassName(cell.cellType)}
            cellItems={cell.cellItems}
            feedbackType={props.feedbackType}
            responses={props.responses}
          />
        );
      case CELL_TYPE.DIALYSIS_PATH:
        return (
          <DialysisPath
            id={props.id}
            key={cell.cellId}
            cellId={getCellId(cell.cellId)}
            columnType={COLUMN_TYPE}
            className={getClassName(cell.cellType)}
            cellItems={cell.cellItems}
            label={props.colItems[0].label}
            feedbackType={props.feedbackType}
            responses={props.responses}
          />
        );
      default:
        return null;
    }
  };

  const style = getGridTemplateRows(props.colItems.length);

  return (
    <div className={props.className} style={style}>
      {props.colItems.map(renderCell)}
    </div>
  );
}

BandColumn.propTypes = {
  /**
   * Component id from the notebook data file
   */
  id: PropTypes.number,
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Unique Id for column
   */
  colId: PropTypes.number,
  /**
   * Items to render in column
   */
  colItems: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * UnqiueId for the cell
       */
      cellId: PropTypes.number,
      /**
       * Type of Cell
       */
      cellType: PropTypes.oneOf([
        CELL_TYPE.LABEL_CELL,
        CELL_TYPE.DIALYSIS_HOLDER,
        CELL_TYPE.DIALYSIS_PATH,
      ]),
      /**
       * Items to be rendered inside the cell
       */
      cellItems: PropTypes.arrayOf(PropTypes.object),
      /**
       * label for the cell [only for LABEL_CELL, EMPTY_DIALYSIS_HOLDER ]
       */
      label: PropTypes.string,
    })
  ),
  /**
   * AriaLabel of the heading
   */
  headingAriaLabel: PropTypes.shape({
    /**
     * Unique key for the data
     */
    key: PropTypes.number,
    /**
     * Label of the Heading
     */
    label: PropTypes.string,
    /**
     * Arialabel to display on the heading
     */
    ariaLabel: PropTypes.string,
  }),
};

BandColumn.defaultProps = {};
